import React, { useState } from 'react';

const AdminCleanArchive = ({ password }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleCleanArchive = async () => {
    if (!window.confirm('Are you sure you want to clean the newsletter archive? This will remove archive links from all newsletters.')) {
      return;
    }

    setLoading(true);
    setError('');
    setResult(null);

    try {
      const response = await fetch('/api/clean-newsletter-archive', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-admin-password': password
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to clean archive');
      }

      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 32 }}>
      <h2>Clean Newsletter Archive</h2>
      <p style={{ marginBottom: 24, color: '#666' }}>
        This tool will remove archive links from all newsletters in the archive. 
        This is useful for cleaning up newsletters that were sent before the archive link was removed from the email content.
      </p>

      <button
        onClick={handleCleanArchive}
        disabled={loading}
        style={{
          padding: '12px 24px',
          fontSize: 16,
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: 6,
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? 'Cleaning Archive...' : 'Clean Archive'}
      </button>

      {error && (
        <div style={{ 
          marginTop: 16, 
          padding: 12, 
          backgroundColor: '#f8d7da', 
          color: '#721c24', 
          borderRadius: 4,
          border: '1px solid #f5c6cb'
        }}>
          Error: {error}
        </div>
      )}

      {result && (
        <div style={{ 
          marginTop: 16, 
          padding: 12, 
          backgroundColor: '#d4edda', 
          color: '#155724', 
          borderRadius: 4,
          border: '1px solid #c3e6cb'
        }}>
          <strong>Success!</strong> {result.message}
          {result.cleaned > 0 && (
            <div style={{ marginTop: 8 }}>
              <strong>Cleaned:</strong> {result.cleaned} newsletters<br />
              <strong>Total:</strong> {result.total} newsletters
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminCleanArchive; 